import { topicGroups } from '@/mocks/homeData';
import SectionHead from './SectionHead';

const hotWords = ['围标串标', '阴阳合同', '删稿与改稿'];

export default function TopicWall() {
  return (
    <section id="hua-ti" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <SectionHead
        index="档案 03"
        kicker="话题墙"
        title="按话题进，别按标题瞎猜"
        desc="同一类事情归档在同一个话题下。点一个 #，就能把所有相关档案按时间叠在一页，比较起来更方便。"
        tone="accent"
      />

      <div className="mt-10 flex flex-col gap-8 lg:flex-row">
        {/* 左侧：热度导览 */}
        <div className="lg:w-72 lg:shrink-0">
          <div className="rounded-lg bg-accent-100/70 p-5">
            <div className="flex items-center gap-2 text-xs font-semibold tracking-widest text-accent-900">
              <i className="ri-fire-line" aria-hidden="true"></i>
              本周热度前三
            </div>
            <ol className="mt-4 space-y-4">
              {hotWords.map((w, idx) => (
                <li key={w}>
                  <a
                    href="#hua-ti"
                    className="flex cursor-pointer items-center gap-3 rounded-md px-2 py-2 transition-colors duration-200 hover:bg-accent-500/90 hover:text-foreground-950"
                  >
                    <span className="font-heading text-xl font-black text-accent-700">0{idx + 1}</span>
                    <span className="flex-1">
                      <span className="block text-sm font-semibold text-foreground-950">#{w}</span>
                      <span className="mt-0.5 block text-xs text-foreground-500">跟进 {68 - idx * 17} 条相关档案</span>
                    </span>
                    <i className="ri-arrow-right-up-line text-accent-700" aria-hidden="true"></i>
                  </a>
                </li>
              ))}
            </ol>
          </div>
          <p className="mt-5 hidden text-sm leading-relaxed text-foreground-500 lg:block">
            热度按近 7 天新增档案与读者核对次数综合计算，动态更新，不代表任何事实判断。
          </p>
        </div>

        {/* 右侧：话题标签墙 */}
        <div className="flex-1">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            {topicGroups.map((g) => (
              <div key={g.group} className="rounded-lg bg-background-100 p-5">
                <div className="flex items-center gap-2 border-b border-background-200 pb-3">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                  <h3 className="font-heading text-sm font-bold text-foreground-950">{g.group}</h3>
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  {g.topics.map((t) => (
                    <a
                      key={t.name}
                      href="#hua-ti"
                      className="flex cursor-pointer items-center gap-1.5 rounded-full bg-background-50 px-3 py-1.5 text-[13px] text-foreground-800 transition-colors duration-200 hover:bg-accent-500 hover:text-foreground-950 whitespace-nowrap"
                    >
                      <span>#{t.name}</span>
                      <span className="text-xs text-foreground-400">{t.count}</span>
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <a
            href="#ru-kou"
            className="mt-6 inline-flex items-center gap-1.5 text-sm text-foreground-700 transition-colors duration-200 hover:text-primary-600 cursor-pointer"
          >
            没找到想盯的话题？告诉我们，拉一个专属档案线
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}